import api from '../../../App/socket';

export const getLeadsMotHistory = bike_details => (
    api.send({
        api: 'module',
        module: 'Leads',
        classMethod: 'MOTLookup',
        options: {
            params: {
                _id: bike_details._id,
                vrm: bike_details.vrm,
            },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/get_leads_mot_history_request.js